// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_page-wrapper__GApzF","header":"PageWrapper_header__eufCN","content":"PageWrapper_content__of9PR","alertWrapper":"PageWrapper_alert-wrapper__XXM-s"};